import { fabric } from 'fabric'

const padding = 20

export default {
  type: 'line',

  isA: function (object) {
    return object.customType === this.type
  },

  new: function (pointer, fillColour, strokeColour, strokeWidth) {
    strokeWidth = strokeWidth || 1

    const line = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      stroke: strokeColour,
      strokeWidth: strokeWidth,
      left: 0
    })

    const group = new fabric.Group([line], {
      customType: this.type,
      left: pointer.x,
      top: pointer.y,
      width: 0, // we don't want it to show up until they start dragging
      height: 0
    })

    return group
  },

  options: function (shape, pointer, shiftKey) {
    const x = shape.left
    const y = shape.top

    const length = Math.sqrt(Math.pow(pointer.x - x, 2) + Math.pow(pointer.y - y, 2))

    const dy = pointer.y - y
    const dx = pointer.x - x
    let angle = Math.atan2(dy, dx)
    angle *= 180 / Math.PI

    // straight line mode
    if (shiftKey) {
      angle = 45 * Math.round(angle / 45)
    }

    return {
      group: {
        width: length,
        height: padding,
        angle: angle,
        originX: 'left',
        originY: 'center'
      },
      objects: [
        {
          x1: -length / 2,
          x2: length / 2,
          y1: 0,
          y2: 0
        }
      ]
    }
  },

  setStroke: function (group, colour) {
    group.item(0).set({ stroke: colour })
  },

  setStrokeWidth: function (group, width) {
    if (width === 0) {
      return
    }

    group.item(0).set({ strokeWidth: width })

    group.set({
      height: padding
    })

    const line = group.item(0)
    line.set({
      top: -width / 2
    })
  },

  getStroke: function (group) {
    return group.item(0).stroke
  },

  getStrokeWidth: function (group) {
    return group.item(0).strokeWidth
  },

  scale: function (group) {
    const width = group.getScaledWidth()

    group.set({
      width: width,
      height: padding,
      scaleX: 1,
      scaleY: 1
    })

    const line = group.item(0)

    line.set({
      x1: -width / 2,
      x2: (width / 2),
      y1: 0,
      y2: 0,
      top: -line.strokeWidth / 2
    })
  },

  controlSettings: function () {
    return {
      lockScalingY: true,
      centeredRotation: false,
      _controlsVisibility: {
        tl: false,
        tr: false,
        br: false,
        bl: false,
        ml: true,
        mt: false,
        mr: true,
        mb: false,
        mtr: true
      }
    }
  }
}
